import type { Xinglet } from '@xing-com/crate-xinglet';

import { MasterDirectoryRootPage } from './root';

export default class MasterDirectoryRoot implements Xinglet {
  public getComponent() {
    return () => <MasterDirectoryRootPage />;
  }
}
